export function IconHand() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 11V6C18 5.46957 17.7893 4.96086 17.4142 4.58579C17.0391 4.21071 16.5304 4 16 4C15.4695 4 14.9608 4.21071 14.5858 4.58579C14.2107 4.96086 14 5.46957 14 6M14 10V4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2C11.4695 2 10.9608 2.21071 10.5858 2.58579C10.2107 2.96086 9.99998 3.46957 9.99998 4V6M9.99998 6V10.5M9.99998 6C9.99998 5.46957 9.78927 4.96086 9.41419 4.58579C9.03912 4.21071 8.53041 4 7.99998 4C7.46955 4 6.96084 4.21071 6.58577 4.58579C6.21069 4.96086 5.99998 5.46957 5.99998 6V14M18 8C18 7.46957 18.2107 6.96086 18.5858 6.58579C18.9608 6.21071 19.4695 6 20 6C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V14C22 16.1217 21.1571 18.1566 19.6568 19.6569C18.1565 21.1571 16.1217 22 14 22H12C9.19998 22 7.49998 21.14 6.00998 19.66L2.40998 16.06C2.06592 15.6789 1.88157 15.1802 1.89511 14.6669C1.90864 14.1537 2.11903 13.6653 2.4827 13.303C2.84638 12.9406 3.33548 12.7319 3.84875 12.7202C4.36202 12.7085 4.86014 12.8946 5.23998 13.24L6.99998 15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        vectorEffect="non-scaling-size"
      />
    </svg>
  );
}
